import { configureStore } from '@reduxjs/toolkit';
import menuReducer from './menuSlice';
import eventsReducer from './eventsSlice';
import organizersReducer from './organizersSlice';
import tokensReducer from './tokensSlice';
import sportsReducer from './sportsTabSlice';
import notificationsReducer from './notificartionsTabSlice';
import opinionsReducer from './opinionsTabSlice';
import opinionsTTabReducer from './opinionsTTabSlice';
import opinionsUTabReducer from './opinionsUTabSlice';
import trainingsReducer from './trainingsTabSlice';
import promoReducer from './promoSlice';
import statsReducer from './statsSlice';
import usersReducer from './usersSlice';
import { normalizeUserRoles } from '../auth/roles';

const TOKENS_STORAGE_KEY = 'mapen_admin_tokens';

const loadPersistedTokensState = () => {
  if (typeof window === 'undefined') return undefined;

  try {
    const raw = window.localStorage.getItem(TOKENS_STORAGE_KEY);
    if (!raw) return undefined;

    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== 'object') return undefined;

    return {
      tokens: {
        ...parsed,
        userRoles: normalizeUserRoles(parsed.userRoles, parsed.userRole),
      },
    };
  } catch (error) {
    console.warn('Nie udało się odczytać zapisanych tokenów z localStorage:', error);
    return undefined;
  }
};

const store = configureStore({
  preloadedState: loadPersistedTokensState(),
  reducer: {
    menu: menuReducer,
    events: eventsReducer,
    organizers: organizersReducer,
    tokens: tokensReducer,
    sports: sportsReducer,
    notifications: notificationsReducer,
    opinions: opinionsReducer,
    opinionsT: opinionsTTabReducer,
    opinionsU: opinionsUTabReducer,
    trainings: trainingsReducer,
    stats: statsReducer,
    promo: promoReducer,
    users: usersReducer
    }});

let lastPersistedTokens = null;
store.subscribe(() => {
  if (typeof window === 'undefined') return;

  const tokensState = store.getState().tokens;
  const serialized = JSON.stringify(tokensState);

  if (serialized === lastPersistedTokens) return;

  try {
    window.localStorage.setItem(TOKENS_STORAGE_KEY, serialized);
    lastPersistedTokens = serialized;
  } catch (error) {
    console.warn('Nie udało się zapisać tokenów do localStorage:', error);
  }
});

export default store;
